var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 372.08,
    y1: 356.33,
    x2: 372.08,
    y2: 485.02,
    gradientTransform: "matrix(1, 0, 0, -1, -275.5, 485.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 371.56,
    y1: 306.57,
    x2: 371.56,
    y2: 356.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 770)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1490df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1f56a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 372.08,
    y1: 400.46,
    x2: 372.08,
    y2: 437.95,
    gradientTransform: "matrix(1, 0, 0, -1, -275.5, 485.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0fffd"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Microsoft Intune logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 193.16,
    height: 128.69,
    rx: 6.4,
    ry: 6.4,
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 10.75,
    width: 171.67,
    height: 107.32,
    rx: 3.58,
    ry: 3.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.84,452.68c-19.19-2.94-20-16.76-19.83-38.38H352.63c0,22.26-.77,36.07-19.83,38.38a11.13,11.13,0,0,0-9.47,10.75h96.45A11.26,11.26,0,0,0,410.84,452.68Z",
    transform: "translate(-275.5 -284.98)",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.74,344.46h-88a29.55,29.55,0,1,0,0,11.77h9.08V478.78A4.22,4.22,0,0,0,414,483h74.58a4.22,4.22,0,0,0,4.22-4.22V348.68A4.22,4.22,0,0,0,488.74,344.46Z",
    transform: "translate(-275.5 -284.98)",
    style: {
      fill: "#32bedd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.25,
    y: 71.12,
    width: 67.41,
    height: 111.29,
    rx: 1.54,
    ry: 1.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.58,
    cy: 65.88,
    r: 18.68,
    style: {
      opacity: 0.8999999761581421,
      isolation: "isolate",
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.45,407.27l-14.33-14.33a.77.77,0,0,0-1.28.64v8.7a.77.77,0,0,1-.77.77H409.81v10.62h33.26a.77.77,0,0,1,.77.77h0v8.83a.77.77,0,0,0,1.28,0l14.33-13.69a1.54,1.54,0,0,0,.14-2.17Z",
    transform: "translate(-275.5 -284.98)",
    style: {
      fill: "#0078d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntune);
export default __webpack_public_path__ + "static/media/Intune.50fd7b3a76840ea4648b86f6f2b489d7.svg";
export { ForwardRef as ReactComponent };